import { createUseStyles } from 'react-jss';

export default createUseStyles({
  grid: {
    display: 'grid',
    gridTemplateRows: 'repeat(16, 1fr)',
    gridTemplateColumns: 'repeat(32, 1fr)',
    width: '50vmin',
    height: '35vmin',
    border: '2px solid black',
    marginLeft: '15%'
  },
  cell: {
    cursor: 'pointer',
    border: '2px solid black',
    background: 'white',
    transition: 'all 200ms linear',
    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
});
